import styled from 'styled-components';

import TextInput from 'web-components/TextInput';

export const GroupInfo = styled.div`
  height: 250px;
  width: 100%;
  background-color: ${props => props.theme.colors.baseBanner};
`;

export const GroupLink = styled(TextInput)`
  font-size: 12px;
  border: 1px solid ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primary};
  border-radius: 4px;
  min-width: 220px;
  padding: 4px;
  height: 31px;
  box-shadow: none !important;
  outline: none !important;
  -webkit-text-fill-color: ${props => props.theme.colors.link} !important;
`;
